import { render, staticRenderFns } from "./ProCardSetManagement.vue?vue&type=template&id=bb97fc34&scoped=true&"
import script from "./ProCardSetManagement.vue?vue&type=script&lang=js&"
export * from "./ProCardSetManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProCardSetManagement.vue?vue&type=style&index=0&id=bb97fc34&prod&lang=scss&scoped=true&"
import style1 from "./ProCardSetManagement.vue?vue&type=style&index=1&id=bb97fc34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97fc34",
  null
  
)

export default component.exports